import { StoreType } from '../redux/store';
import { Navigate } from 'react-router';
import { getEditorRoutes } from './editor-routes';
import { getReviewerRoutes } from './reviewer-routes';
import { convertModuleWithStore } from './routes.helper';


export const getAllRoutes = (store: StoreType) => {  
  const allRoutes = [
    {
      lazy: async () => convertModuleWithStore(await import('./root'), store),
      children: [
        ...(import.meta.env.SSR ? [] : [
          {
            path: "/signed",
            element: <Navigate to="/" replace={true} />,
          },
          {
            path: "/signedout",
            element: <Navigate to="/" replace={true} />,
          },
          getEditorRoutes(store),
          getReviewerRoutes(store)
        ]),
        {
          path: 'user/profile',
          lazy: async () => convertModuleWithStore(await import('./user.profile'), store),
        },
        {
          path: '/:page?',
          children: [
            {
              path: '*',
              lazy: async () => convertModuleWithStore(await import('./post-viewer.splat'), store),
            },
            {
              index: true,
              lazy: async () => convertModuleWithStore(await import('./_index'), store),
            }
          ]
        },
      ],
    }
  ];
  return allRoutes;
}
